import React from "react";
import "./index.scss";

const DocumentUpload = ({ label, name, file, onChange, required = false }) => (
  <div className="doc-upload-wrapper">
    <label className="doc-upload-label" htmlFor={name}>
      {label}
      {required && <span className="required-mark"> *</span>}
    </label>
    <div className={`doc-upload-box ${file ? "has-file" : ""}`}>
      <input
        id={name}
        type="file"
        name={name}
        accept=".pdf,.jpg,.jpeg,.png"
        className="doc-upload-input"
        onChange={onChange}
      />
      <span className="doc-upload-text">
        {file ? file.name : "Click to upload (PDF / JPG / PNG)"}
      </span>
    </div>
  </div>
);

export default DocumentUpload;
